import { createContext, useContext } from 'react';

export const SelectContext = createContext();
export const useSelectContext = () => {
  const context = useContext(SelectContext);
  if (!context) {
    throw new Error(
      'SelectBox cannot be rendered outside the SelectBox component',
    );
  }
  return context;
};
